import { ITag } from "./Models/ITag";
import { SubscribableCollectionWithBackingStore } from "./SubscribableWithBackingStore";
export type TagKey = string; // [Guid, string];
export class TagSubscribable extends SubscribableCollectionWithBackingStore<ITag> {}
